import { combineReducers } from "redux";
import { cartMini, cartSlice, checkout, freeTrialCart, loyalty, loyaltyApiSlice, loyaltyCore, magentoApiSlice, onePageCheckoutForm, order, profileApiSlice, standardCheckoutForm, } from "./slices";
export const rootReducer = combineReducers({
    cart: cartSlice.reducer,
    freeTrialCart: freeTrialCart.reducer,
    checkout: checkout.reducer,
    standardCheckoutForm: standardCheckoutForm.reducer,
    onePageCheckoutForm: onePageCheckoutForm.reducer,
    order: order.reducer,
    cartMini: cartMini.reducer,
    loyalty: loyalty.reducer,
    loyaltyCore: loyaltyCore.reducer,
    [magentoApiSlice.reducerPath]: magentoApiSlice.reducer,
    [loyaltyApiSlice.reducerPath]: loyaltyApiSlice.reducer,
    [profileApiSlice.reducerPath]: profileApiSlice.reducer,
});
//# sourceMappingURL=rootReducer.js.map